export default {"src":"/_next/static/media/ALGM.bd7423a6.svg","height":18,"width":18};